import { InitialRepackPallets } from "../../interfaces/intakes.repack"
import { ImageType, InitialPallets } from "../../interfaces/intakes.reports"

interface Props {
    pallets: InitialPallets[] | InitialRepackPallets[]
    mainDataImages?: ImageType[]
}

export const CoverImage = ({ pallets, mainDataImages = []}: Props) => {

    let coverImage: ImageType | undefined = pallets?.find(cover => cover.images.length > 0)?.images[0]


    if (!coverImage) {

        const palletsImages = pallets.map(pallet => {
            let images: ImageType[] = [...pallet.labels?.images || [], ...pallet.appearance?.images || []]
            if ('pallgrow' in pallet) images.push(...pallet.pallgrow?.images || [])

            return images
        }).flat()

        coverImage = palletsImages.find(cover => cover.imgURL_low || cover.imgURL)
    }

    const cover = mainDataImages.length > 0 ? mainDataImages[0].imgURL_low : coverImage ? coverImage?.imgURL_low : "/assets/img/no-image.jpg" 

    return (
        <img src={ cover } alt="img-pallet" loading='lazy' style={{ width: "100%", height: "100%", objectFit: "cover" }} />
    )
}

